export default __webpack_public_path__ + "static/woaO-904c2b191840231183740185efbfdd4e.png";